export const slugifyTourTitle = (value = '') =>
  String(value)
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getTourSlug = (tour = {}) =>
  tour.slug || slugifyTourTitle(tour.title) || String(tour.id || '');

export const withTourSlug = (tour = {}) => ({
  ...tour,
  slug: getTourSlug(tour),
});

export const withTourSlugs = (tours = []) => tours.map(withTourSlug);

export const tourPath = (tour = {}) => `/explore/${getTourSlug(tour)}`;

export const bookingPath = (tour = {}) => `/book-now/${getTourSlug(tour)}`;

export const enquirePath = (tour = {}) => `/enquire/${getTourSlug(tour)}`;

export const findTourByParam = (tours = [], param = '') => {
  const value = String(param || '').trim().toLowerCase();
  if (!value) return null;

  return tours.find((tour) => {
    const id = String(tour.id || '');
    const slug = getTourSlug(tour);
    return id === value || slug === value;
  }) || null;
};
